module.exports = __webpack_public_path__ + "static/img/cont64 (6).26a6166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (6).jpg
// module id = /obA
// module chunks = 0